import React from 'react';
import styled from 'styled-components';
import Button from 'components/Button';
import { isMobile } from 'react-device-detect';

const ShowMoreButtonContainer = styled.div`
  display: flex;
  width: 100%;
`;

const ShowMoreButton = ({
  label,
  onClick
}: {
  label: any;
  onClick: () => void;
}) => (
  <ShowMoreButtonContainer>
    <Button
      width={isMobile ? '100%' : '200px'}
      label={label}
      color="white"
      textColor="black"
      textTransform="normal"
      border="1px #2B3D54 solid"
      fontFamily="SFCompactText"
      fontSize="12px !important"
      onClick={() => onClick()}
      icon={undefined}
    />
  </ShowMoreButtonContainer>
);

export default ShowMoreButton;
